import appConfigCoverGoProd from "./appConfigCoverGoProd"
import { COVERGO_SAAS_PROD } from "../consts.js"

export const gogox = {
	// CoverGo PROD
	"gogox-uat-studio.quote.hk": {
		appConfig: appConfigCoverGoProd,
		envConfig: COVERGO_SAAS_PROD
	}
}
